/**
 * .videolist 내 a[data-youtube-id] 클릭 시 .videomodal 열고 유튜브 iframe 재생.
 * .videoclose 클릭 시 모달 닫기.
 */
export function initVideoModal(): void {
  const modal = document.querySelector<HTMLElement>(".videomodal");
  const container = document.querySelector<HTMLElement>(".videomodal .videocontainer");
  const closeBtn = document.querySelector<HTMLElement>(".videomodal .videoclose");

  if (!modal || !container) return;

  document.addEventListener("click", (e) => {
    const inList = (e.target as Element).closest?.(".videolist");
    if (!inList) return;

    const link = (e.target as Element).closest?.(".videolist li")?.querySelector?.("a[data-youtube-id]");
    if (!link) return;

    const id = (link as HTMLElement).dataset.youtubeId?.trim();
    if (!id) return;

    e.preventDefault();

    const src = `https://www.youtube.com/embed/${id}?autoplay=1&rel=0`;
    container.innerHTML = `<iframe width="100%" height="100%" src="${src}" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`;
    modal.classList.add("show");
  });

  function close(): void {
    modal.classList.remove("show");
    container.innerHTML = "";
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", close);
  }

  modal.addEventListener("click", (e) => {
    if (e.target === modal) close();
  });
}
